import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Tool, RefreshCw } from 'react-feather'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

const MaintenanceScreen: React.FC = () => {
  const [retrying, setRetrying] = useState(false)

  // Poll the backend every 10s. A successful response triggers the global
  // `backend-available` event via the axios response interceptor, which flips
  // the maintenance screen off in App.tsx.
  useEffect(() => {
    const ping = () => {
      axios.get(`${API_BASE_URL}/ping`, { timeout: 5000 }).catch(() => {})
    }
    ping()
    const id = setInterval(ping, 10000)
    return () => clearInterval(id)
  }, [])

  const handleRetry = async () => {
    if (retrying) return
    setRetrying(true)
    try {
      // Probe with a bare axios instance so this request bypasses the global
      // interceptor's failure counter — we don't want a single failed retry
      // click to push us further into the down state.
      await axios.create().get(`${API_BASE_URL}/ping`, { timeout: 5000 })
      window.location.reload()
    } catch {
      setRetrying(false)
    }
  }

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-amber-500/10 flex items-center justify-center">
            <Tool size={40} className="text-amber-400" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-white">We'll be right back</h1>
          <p className="text-gray-400">
            Intellasure is temporarily unavailable while we make updates. Your data is safe.
          </p>
        </div>

        <div className="bg-dark-card border border-dark-border rounded-xl p-4 space-y-3">
          <div className="flex items-center gap-3">
            <RefreshCw size={18} className="text-gray-500 flex-shrink-0" />
            <p className="text-sm text-gray-300 text-left">
              This page will refresh automatically when the service is back online. You can also try reloading manually.
            </p>
          </div>
        </div>

        <button
          onClick={handleRetry}
          disabled={retrying}
          className="px-6 py-2.5 bg-dark-card border border-dark-border rounded-xl text-sm text-gray-300 hover:text-white hover:border-gray-500 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {retrying ? 'Checking…' : 'Retry Now'}
        </button>
      </div>
    </div>
  )
}

export default MaintenanceScreen
